import React from 'react';
import { Outlet } from 'react-router-dom';

export function ListSchoolSo() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  );
}
